(() => {
  if (customElements.get('vc-surface-order')) return;
  class SurfaceOrder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-order-config]').textContent);
      this.form = document.getElementById(this.dataset.formId);
      this.area = this.querySelector('[data-area]');
      this.boxes = this.querySelector('[data-boxes]');
      this.waste = this.querySelector('[data-waste]');
      this.variantSelect = this.querySelector('[data-variant]');
      this.variant = this.config.variants.find(v => v.id === this.config.initial);
      this.mode = 'boxes';
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency',currency:this.dataset.currency || 'CAD'});
      this.area.addEventListener('input', () => {this.mode='area'; this.update();});
      this.boxes.addEventListener('input', () => {this.mode='boxes'; this.update();});
      this.waste.addEventListener('change', () => this.update());
      this.variantSelect?.addEventListener('change', () => {
        this.variant = this.config.variants.find(v => String(v.id) === this.variantSelect.value);
        const original = this.form?.querySelector('[name="id"]');
        if (original) {original.value=String(this.variant.id); original.dispatchEvent(new Event('change',{bubbles:true}));}
        this.update();
      });
      this.querySelector('[data-use-room]').addEventListener('click', () => {
        const length=Number(this.querySelector('[data-room-length]').value), width=Number(this.querySelector('[data-room-width]').value);
        if (length>0 && width>0) {this.area.value=(length*width).toFixed(2);this.mode='area';this.update();this.querySelector('[data-room-panel]').open=false;}
      });
      this.form?.addEventListener('submit', event => {
        this.update();
        if (!this.valid) {event.preventDefault();event.stopImmediatePropagation();this.querySelector('[data-error]').hidden=false;}
      }, true);
      this.update();
    }
    update() {
      const v=this.variant, coverage=Number(v.coverage), review=this.dataset.review==='true' && !v.variantCoverage;
      const usable=coverage>0 && !review;
      this.area.disabled=!usable;this.waste.disabled=!usable;
      this.querySelector('[data-room-panel]').hidden=!usable;
      this.querySelector('[data-review-note]').hidden=!review;
      this.querySelector('[data-box-coverage]').hidden=!usable;
      this.querySelector('[data-box-price-row]').hidden=!usable;
      this.querySelector('[data-coverage-row]').hidden=!usable;
      this.querySelector('[data-unit-price]').textContent=this.money.format((usable?v.price/coverage:v.price)/100);
      this.querySelector('[data-unit-label]').textContent=usable?this.config.labels.perSqft:this.config.labels.perBox;
      this.querySelector('[data-box-price]').textContent=this.money.format(v.price/100);
      const coverageLabel=this.querySelector('[data-box-coverage]');
      if(usable) coverageLabel.textContent=`· ${coverage.toLocaleString('en-CA',{maximumFractionDigits:3})} sq. ft. / box`;
      const sku=this.querySelector('[data-sku]');if(sku)sku.textContent=v.sku;
      let boxes=Number(this.boxes.value);
      if(this.mode==='area' && usable){
        const area=Number(this.area.value);
        boxes=area>0?Math.max(Number(this.config.minimum),Math.ceil((area*(this.waste.checked?1.1:1)-1e-9)/coverage)):0;
        this.boxes.value=boxes||'';
      }
      this.valid=Number.isInteger(boxes)&&boxes>=Number(this.config.minimum)&&boxes<=Number(this.config.maximum)&&v.available;
      const qty=this.form?.querySelector('[name="quantity"]');if(qty)qty.value=this.valid?String(boxes):'0';
      this.querySelector('[data-coverage]').textContent=(Math.max(0,boxes||0)*coverage).toLocaleString('en-CA',{maximumFractionDigits:2});
      this.querySelector('[data-total]').textContent=this.money.format((Math.max(0,boxes||0)*v.price)/100);
      const error=this.querySelector('[data-error]');error.textContent=this.config.labels.invalid;error.hidden=this.valid;
      const submit=this.form?.querySelector('[type="submit"]');if(submit)submit.disabled=!this.valid;
    }
  }
  customElements.define('vc-surface-order',SurfaceOrder);
})();
